import React from 'react'
import { Link } from 'react-router-dom';
import HomeGallery from '../home/HomeGallery';


const Gallery = () => {
    return (
        <>

            <div className="breadcrumb-wrapper bg-cover" style={{ backgroundImage: 'url("assets/img/breadcrumb-bg.png")' }}>
                <div className="sun-shape">
                    <img src="assets/img/sun.png" alt="shape-image" />
                </div>
                <div className="cloud-shape float-bob-x">
                    <img src="assets/img/cloud.png" alt="shape-image" />
                </div>
                <div className="perashute-shape float-bob-y">
                    <img src="assets/img/perasute.png" alt="shape-image" />
                </div>
                <div className="tree-shape">
                    <img src="assets/img/tree.png" alt="shape-image" />
                </div>
                <div className="bottom-shape">
                    <img src="assets/img/breadcrumb-shape.png" alt="img" />
                </div>
                <div className="container">
                    <div className="page-heading">
                        <ul className="breadcrumb-items wow fadeInUp" data-wow-delay=".3s" style={{ visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeInUp' }}>
                            <li>
                                <Link to="/">Home</Link>
                            </li>
                            <li> Our Gallery</li>
                        </ul>
                        <h1 className="char-animation" style={{ perspective: 300 }}>
                            Our Gallery
                            {/* <div style={{ position: 'relative', display: 'inline-block' }}><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>G</div><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>a</div><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>l</div><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>l</div><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>e</div><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>r</div><div style={{ position: 'relative', display: 'inline-block', opacity: 1, visibility: 'inherit', transform: 'translate(0px, 0px)' }}>y</div></div> */}
                        </h1>
                    </div>
                </div>
            </div>
            <div className='mt-lg-5' style={{marginTop:""}}>
                <HomeGallery />
            </div>


        </>
    )
}

export default Gallery